import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MaterialModule } from "../../material/material.module";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

export class WelcomeDialogContent {
    public links:Link[] = []

    constructor(public title:string, public paragraphs:string[]){
        this.links = [new Link("close", "Close")]
    }
}

export class Link {
    constructor(public action:string, public label:string, public tooltip?:string) {}
}

@Component({
    selector: 'welcome-dialog',
    templateUrl: 'welcome-dialog.html',
    imports: [MaterialModule],
    standalone: true,
    styleUrls: ['welcome-dialog.css']
})
export class WelcomeDialogComponent {
    safeParagraphs:SafeHtml[]
   
    constructor(public dialogRef: MatDialogRef<WelcomeDialogComponent>, @Inject(MAT_DIALOG_DATA) public data:WelcomeDialogContent, private sanitizer: DomSanitizer) {
        this.safeParagraphs = data.paragraphs.map(p => this.sanitizer.bypassSecurityTrustHtml(p))
    }

    closeDialog(action:string) {
        this.dialogRef.close(action);
    }
}
